import { render, staticRenderFns } from "./DecidedProposals.vue?vue&type=template&id=0732cf43&"
import script from "./DecidedProposals.vue?vue&type=script&lang=js&"
export * from "./DecidedProposals.vue?vue&type=script&lang=js&"
import style0 from "./DecidedProposals.vue?vue&type=style&index=0&id=0732cf43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports